import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  private pathApi = this.config.setting['pathApi'] + "utility/";

  constructor(private http: HttpClient, private config: AppConfig) { }
  
  getAllForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForOptions`);
  } 
}
